module.exports = __webpack_public_path__ + "static/media/002.a3ece0ce.jpg";